import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Input, Checkbox, Button, Affix, message, Select, Card } from 'antd';
import Sidebar from './ChatSidebar';
import MessageList from './MessagePanel';
import MessageInput from './MessageInput';
import ChatHeader from './ChatHeader';
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import Cookies from 'js-cookie';
import ActionCable from 'actioncable';
import GroupModal from './CreateGroupChat';
import ChatSection from './ChatSection';
import { configConsumerProps } from 'antd/es/config-provider';
import { use } from 'react';

const { Option } = Select;

const Chat = () => {
    const [people, setPeople] = useState([]); // Store fetched users
    const [messages, setMessages] = useState([]); // Store messages for each user
    const [selectedUser, setSelectedUser] = useState(null); // Currently selected user
    const [selectedChatId, setSelectedChatId] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility state
    const [groupUsers, setGroupUsers] = useState([]); // Selected users for the group
    const [groupName, setGroupName] = useState(''); // Group name
    const [groups, setGroups] = useState([]); // Store groups
    const [selectedGroup, setSelectedGroup] = useState(null); // Currently selected group
    const [groupVisibility, setGroupVisibility] = useState('public');
    const [recentDirectChats, setRecentDirectChats] = useState(null);
    const [isGroupChat, setIsGroupChat] = useState(false);
    const [isDirectChat, setIsDirectChat] = useState(false);
    const [typingUser, setTypingUser] = useState(null);
    const [chatType, setChatType] = useState('null');
    const [sample, setSample] = useState(null);
    const [typingPerson, setTypingPerson] = useState(null);
    const currentUserId = Cookies.get('userId');
    const currentUserName = Cookies.get('name');
    const currentUser = { id: currentUserId, name: currentUserName };


    useEffect(() => {
        if (!cableApp.current) {
            cableApp.current = ActionCable.createConsumer('ws://localhost:4000/cable');
        }
    }, []);
    const cableApp = useRef(null); // Ref to store WebSocket connection
    const subscriptionRef = useRef(null);

    useEffect(() => {
       
            let typingTimeout;
            subscriptionRef.current = cableApp.current.subscriptions.create(
                { channel: 'ChatChannel', room: selectedChatId },
                {
                    received: (data) => {
                        if (data?.type === 'typing') {
                            setTypingPerson(data?.content);
                    
                            // Clear any existing timeout
                            clearTimeout(typingTimeout);
                    
                            // Set a timeout to reset typingPerson after 3 seconds
                            typingTimeout = setTimeout(() => {
                                setTypingPerson(null);
                                setTypingUser(null);
                            }, 3000);
                        } 
                        else {
                            setMessages((prevMessages) => {
                                const updatedMessages = [...prevMessages, data];
                                return updatedMessages;
                            });
                            setTypingPerson(null); // Reset typingPerson when a message is received
                            setTypingUser(null);
                            
                            // Clear any existing timeout if message is received
                            clearTimeout(typingTimeout);
                        }
                    },
                    sendTypingNotification(typingUser) {
                        if(typingUser){
                        this.send({
                            type: 'typing',
                            user_name: typingUser
                        });
                        }

                    },
                }
            );

            // Example of how to call sendTypingNotification when needed
            if (subscriptionRef.current) {
                subscriptionRef.current.sendTypingNotification(typingUser);
            }

            // Clean up the subscription on unmount or user change
            return () => {
                if (!subscriptionRef.current) {
                    subscriptionRef.current.unsubscribe();
                }
            };
        
    }, [selectedChatId, typingUser]);

    useEffect(() => {
        if (typingUser === currentUserName) {
            setTypingPerson(null);
        }
    }, [typingPerson, typingUser]);

    useEffect(() => {
        const subscription = cableApp.current.subscriptions.create(
            { channel: 'UserChannel', user_id: currentUserId },
            {
                received: (data) => {
                    console.log('Received data from WebSocket:', data);
                },
            }
        );
        return () => {
            subscription.unsubscribe();
        }
    }, []);

    useEffect(() => {
        const fetchGroups = async () => {
            const apiService = new ApiService(
                `${BASE_URL}/get_chat/${currentUserId}`, // API endpoint for fetching all chats
                { 'Content-Type': 'application/json' },
                'GET'
            );

            try {
                const response = await apiService.makeCall();

                const directChats = response.filter(chat => chat.chat_type === 'direct');

                // Step 2: Sort the filtered chats by `updated_at` in descending order
                const sortedChats = directChats.sort((a, b) => new Date(b.last_message_at) - new Date(a.last_message_at));

                // Step 3: Take the first 5 chats
                const recentChats = sortedChats.slice(0, 9);

                // Step 4: Set them to `showRecentDirectChats`
                setRecentDirectChats(recentChats);

                // Filter groups with `chat_type` as 'group'
                // Filter groups with `chat_type` as 'group' and include the current user
                const groupChats = response.filter(
                    (chat) => chat.chat_type === 'group' && chat.users.some(user => user._id === currentUserId)
                );
                setGroups(groupChats);
            } catch (error) {
                message.error('Error fetching groups');
            }
        };

        fetchGroups(); // Fetch groups when the component mounts
    }, []);

    useEffect(() => {

        const fetchUsers = async () => {
            const apiService = new ApiService(
                `${BASE_URL}/fetch_records/User`, // Adjust to the correct API endpoint
                { 'Content-Type': 'application/json' },
                'GET'
            );

            try {
                const response = await apiService.makeCall();

                // Filter out the current user based on the ID
                const filteredPeople = response?.records?.filter(person => person._id !== currentUserId);

                setPeople(filteredPeople); // Set the users in the state
            } catch (error) {
                message.error('Error fetching users');
            }
        };

        fetchUsers(); // Fetch users when the component mounts
    }, [currentUserId]);

    const FetchMessages = async (id) => {

        try {

            const chats = new ApiService(`${BASE_URL}/chats/${id}`, {}, 'GET');
            const res = await chats.makeCall();

            return res;
        }
        catch (error) {

        }
    }

    const fetchChatID = async (Userid) => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/get_chat/${Userid}`, // Adjust to the correct API endpoint
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const res = await apiService.makeCall();

            if (res && Array.isArray(res)) {
                // Traverse through the response array


                const matchingChat = res.find(chat => {
                    // Check if chat_type matches and currentUserId exists in the users array
                    return (
                        chat.chat_type === "direct" &&
                        chat.users.some(user => user._id === currentUserId) &&
                        chat.users.some(user => user._id === Userid)
                    );
                });



                if (matchingChat) {
                    setRecentDirectChats((prevChats) => {
                        // Filter out any chat with the same _id as matchingChat
                        const filteredChats = prevChats.filter(chat => chat._id !== matchingChat._id);

                        // Add the matching chat at the start
                        const updatedChats = [matchingChat, ...filteredChats];

                        // Ensure the length remains 9 by slicing off extra items
                        return updatedChats.slice(0, 9);
                    });

                    // If a matching chat is found, set the selected chat ID
                    setSelectedChatId(matchingChat._id);
                    return matchingChat._id;
                }
            }

            // If no matching chat is found, return null
            return null;
        }
        catch (error) {
            return null;
        }

    };

    const handleSelectUser = async (user) => {

        setSelectedUser(user); // Set the selected user
        setIsDirectChat(true);
        setChatType('direct');
        const body = {
            name: "General chat",
            chat_type: "direct",
            users_id: [currentUserId, user._id]
        }
        try {
            const chatExists = await fetchChatID(user._id); // Await the result
            if (chatExists != null) {
                const res = await FetchMessages(chatExists);
                setMessages(res?.messages || []);
                return; // Exit if the chat already exists
            }
            const createChat = new ApiService(`${BASE_URL}/chats`, {}, 'POST', {
                chat: body,
            });
            const res = await createChat.makeCall();
            setRecentDirectChats((prevChats) => {
                // Add the matching chat at the start
                const updatedChats = [res, ...prevChats];

                // Ensure the length remains 9 by slicing off extra items
                return updatedChats.slice(0, 9);
            }); setSelectedChatId(res._id);
            setMessages([]);
        } catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to create chat due to an unknown error';
            message.error(errorMessage);
        }
    };

    const stripHtmlTags = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    // Function to send a message

    const handleSendMessage = async (messageContent) => {
        const body = {
            content: messageContent,
            chat_id: selectedChatId,
            user_id: currentUserId
        }

        try {

            const sendMessage = new ApiService(`${BASE_URL}/messages`, {}, 'POST', {
                message: body,
            });
            const res = await sendMessage.makeCall();

            const message = await FetchMessages(res.chat_id);
            setTypingUser(null);
            setTypingPerson(null);
            setMessages(message?.messages);


        }

        catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to send message due to an unknown error';
            message.error(errorMessage);

        }

    }

    const handleSelectGroup = async (group) => {

        setSelectedUser(null);
        setSelectedGroup(group);
        setSelectedChatId(group._id);
        setIsGroupChat(true);
        let res = [];
        try {
            res = await FetchMessages(group._id);
        } catch (error) {

        }
        setMessages(res?.messages || []);
    }

    // Show the modal
    const showModal = () => setIsModalVisible(true);

    // Hide the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setGroupUsers([]);
        setGroupName('');
    };


    const handleGroupVisibility = (e) => {
        setGroupVisibility(e);
    }
    const handleCreateGroup = async () => {
        if (!groupName) {
            message.error('Group name is required');
            return;
        }

        if (groupUsers.length === 0) {
            message.error('Select at least one user to create a group');
            return;
        }


        const body = {
            name: groupName,
            chat_type: 'group',
            users_id: [currentUserId, ...groupUsers],
        };

        try {
            const apiService = new ApiService(`${BASE_URL}/chats`, {}, 'POST', {
                chat: body,
            });
            const response = await apiService.makeCall();

            // Add the new group to the list of groups
            setGroups((prevGroups) => [...prevGroups, response]);

            message.success('Group created successfully');
            handleCancel();
        } catch (error) {
            message.error('Failed to create group');
        }
    };


    const handleGroupUsers = (e) => {
        setGroupUsers(e);
    }

    const handleGroupName = (e) => {
        setGroupName(e);
    }

    const typingMethod = (userName) => {
        if (userName) {
            setTypingUser(userName);
        } else {
            setTypingPerson(null);
            setTypingUser(null);
        }

    }

    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: '0 0 20%', backgroundColor: '#f0f0f0', borderRight: '1px solid #ddd', overflowY: 'auto' }}>
                <Sidebar
                    people={people}
                    groups={groups}
                    recentDirectChats={recentDirectChats}
                    currentUserId={currentUserId}
                    onAddGroup={showModal}
                    onSelectUser={handleSelectUser}
                    onSelectGroup={handleSelectGroup}
                    setIsDirectChat={setIsDirectChat}
                    setIsGroupChat={setIsGroupChat}
                    setChatType={setChatType}
                    chatType={chatType}
                    sample={sample}
                />
            </div>

            {/* Chat Section */}
            <div style={{ flex: '0 0 80%', display: 'flex', flexDirection: 'column', marginBottom: 0 }}>
                <ChatSection
                    selectedUser={selectedUser}
                    selectedGroup={selectedGroup}
                    chatType={chatType}
                    messages={messages}
                    currentUser={currentUser}
                    handleSendMessage={handleSendMessage}
                    people={people}
                    typingMethod={typingMethod}
                    selectedChatId={selectedChatId}
                    typingPerson={typingPerson}
                    setTypingPerson={setTypingPerson}

                />
            </div>

            {/* Group Modal */}
            <GroupModal
                isModalVisible={isModalVisible}
                handleCancel={handleCancel}
                groupUsers={groupUsers}
                groupName={groupName}
                handleGroupName={handleGroupName}
                handleGroupUsers={handleGroupUsers}
                handleCreateGroup={handleCreateGroup}
                people={people}
                visibility={groupVisibility}
                handleVisibility={handleGroupVisibility}
            />

        </div>

    );
};

export default Chat;